import auth from './auth'

export default function middlewares(router) {
  router.beforeEach((...arg) => {
    auth(...arg)
  })
}
